import React, { Suspense, useMemo } from 'react';
import styled, { StyleSheetManager } from 'styled-components';
import { PageLoading } from 'components/atoms/loading';
import { useAccountDataQuery } from 'queries/account';
import { NotFound } from 'routes/404';
import type { HostAPI } from 'types/host-components';

const SignalAgentsApp = React.lazy(() =>
  import('agentBuilder/SignalAgentsApp').then((module) => ({
    default: module.SignalAgentsApp,
  })),
);

const SignalAgentsWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const SignalAgentsRemote: React.FC = () => {
  const { data: accountData } = useAccountDataQuery();
  const isScarletEnabled = accountData?.accountMeta?.features?.scarlet ?? false;

  // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
  const hostAPI: HostAPI = useMemo(
    () => ({
      // Signal agents currently doesn't request host components.
      renderComponent: () => null,
    }),
    [],
  );

  if (!isScarletEnabled) {
    return <NotFound />;
  }

  return (
    <Suspense fallback={<PageLoading />}>
      <StyleSheetManager target={document.head}>
        <SignalAgentsWrapper className="bg-[var(--scarlet-gray-80)] p-3">
          <SignalAgentsApp hostAPI={hostAPI} />
        </SignalAgentsWrapper>
      </StyleSheetManager>
    </Suspense>
  );
};
